import _ from 'underscore'
import {EntityType} from 'constants'
import {getLocalStorage} from '../../util/LocalStorage'
import {NUMBER_ALLOWED_CHARACTERS} from './constants'

const DEBOUNCE_DELAY = 500

export const setTaskNewCommentsTextsInLocalStorage = _.debounce((newComments) => {
    getLocalStorage().setItem('taskPanelNewComments', newComments)
}, DEBOUNCE_DELAY)

export const setProjectNewCommentsTextsInLocalStorage = _.debounce((newComments) => {
    getLocalStorage().setItem('projectPanelNewComments', newComments)
}, DEBOUNCE_DELAY)

export const setCustomerNewCommentsTextsInLocalStorage = _.debounce((newComments) => {
    getLocalStorage().setItem('customerPanelNewComments', newComments)
}, DEBOUNCE_DELAY)

export const setEntityCommentsInLocalStorage = (entityType, newComments) => {
    switch (entityType) {
        case EntityType.TASK :
            setTaskNewCommentsTextsInLocalStorage(newComments)
            break
        case EntityType.PROJECT :
            setProjectNewCommentsTextsInLocalStorage(newComments)
            break
        case EntityType.CUSTOMER :
            setCustomerNewCommentsTextsInLocalStorage(newComments)
            break
    }
}

export const getTaskNewCommentsTextsFromLocalStorage = () => {
    const comments = getLocalStorage().getItem('taskPanelNewComments')
    return comments ? comments : {}
}

export const getProjectNewCommentsTextsFromLocalStorage = () => {
    const comments = getLocalStorage().getItem('projectPanelNewComments')
    return comments ? comments : {}
}

export const getCustomerNewCommentsTextsFromLocalStorage = () => {
    const comments = getLocalStorage().getItem('customerPanelNewComments')
    return comments ? comments : {}
}

export const validateCommentText = (text) => {
    return text !== '' && text.length <= NUMBER_ALLOWED_CHARACTERS
}

export const getCommentsOrderFromLocalStorage = () => {
    return !!getLocalStorage().getItem('entityPanelsCommentsOrder_newCommentsOnTop')
}

export const setCommentsOrderInLocalStorage = (isNewCommentsOnTop) => {
    getLocalStorage().setItem('entityPanelsCommentsOrder_newCommentsOnTop', isNewCommentsOnTop)
}


// WEBPACK FOOTER //
// ./web/js/panels/comments/utils.js